import { Component, OnInit, ViewChild, TemplateRef, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';

@Component({
  selector: 'app-landpage',
  templateUrl: './landpage.component.html',
  styleUrls: ['./landpage.component.scss']
})
export class LandpageComponent implements OnInit {
  @ViewChild('loginModal') loginModal: TemplateRef<any>;
  loginForm: FormGroup;
  modalRef: NgbModalRef;

  constructor(
    private fb: FormBuilder,
    private modalService: NgbModal,
    private router: Router
  ) {
    this.loginForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(6)]],
      rememberMe: [false]
    });
  }

  ngOnInit(): void {
  }

  scrollToSection(sectionId: string) {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  login() {
    this.router.navigate(['/login']);
  }

  tradutor() {
    this.router.navigate(['/tradutor']);
  }

  pesquisador() {
    this.router.navigate(['/pesquisador']);
  }
} 